"use strict";

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSystemClose = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _core = require("@emotion/core");

var IconSystemClose = function IconSystemClose(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, _core.jsx)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, props), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    id: "a",
    d: "M1.707.293L7 5.585 12.293.293a1 1 0 011.414 1.414L8.415 7l5.292 5.293a1 1 0 01-1.414 1.414L7 8.415l-5.293 5.292a1 1 0 11-1.414-1.414L5.585 7 .293 1.707A1 1 0 111.707.293z"
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, (0, _core.jsx)("path", {
    d: "M0 0H48V48H0z"
  }), (0, _core.jsx)("g", {
    transform: "translate(17 17)"
  }, (0, _core.jsx)("mask", {
    id: "b",
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#a"
  })), (0, _core.jsx)("use", {
    fill: "#889",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), (0, _core.jsx)("g", {
    fill: color,
    mask: "url(#b)"
  }, (0, _core.jsx)("path", {
    d: "M0 0H48V48H0z",
    transform: "translate(-17 -17)"
  })))));
};

exports.IconSystemClose = IconSystemClose;
IconSystemClose.displayname = 'IconSystemClose';
process.env.NODE_ENV !== "production" ? IconSystemClose.propTypes = {
  color: _propTypes.string
} : void 0;
IconSystemClose.defaultProps = {
  color: '#566'
};